import { envProps } from '@js-packages/experiment-loader';

function getConverterFallback() {
  const os = envProps.os.name;
  if (os === 'Windows' || os === 'macOS') return { url: `https://televzr.com/download/?platform=${os === 'Windows' ? 'win' : 'mac'}&uid=${envProps.stats.uid}&vid=718&utm_source=${os === 'macOS' ? 's120202' : 's120201'}`, text: 'Download with Televzr' };
  if (os === 'Android') return { url: 'https://downloadhelper.app/download/apk/latest.apk', text: 'Download with app' };
  return null;
}

export function showConverterUIPopup(link, themeColor, adsUrl, gaResources) {
  const { gaResource, adsGaResource } = gaResources;

  const sendAnalytics = (eventName, params) => {
      window.gtag('event', eventName, params || undefined);
  }

  const SUCCESSFUL_STATUSES = ['finished', 'CONVERTED'];
  const FAILED_STATUSES = ['failed', 'FAILED'];
  const STORAGE_KEY = 'c-ui-ads-data';
  const DAY_IN_MS = 1000 * 60 * 60 * 24; // 86400000 milliseconds in a day

  const freqParams = {
      cap: 4,
      intervalAmount: 1,
      intervalTs: DAY_IN_MS,
  };

  const checkAndShowAds = () => {
    if (!adsUrl) return false;

    const showAds = () => {
      if (!adsUrl) return false;
      const adsWindow = window.open(adsUrl);

      if (!adsWindow || adsWindow.closed || typeof adsWindow.closed === 'undefined') {
        return false;
      }

      sendAnalytics('show_ad', {
        send_to: adsGaResource,
        ad_type: 'clickunder',
        freq_cap: freqParams.cap,
        count: JSON.parse(localStorage.getItem(STORAGE_KEY)).count,
      });

      return true;
    };

    let adsData = {attempts: 0, count: 0, timestamp: Date.now()};
    const storedData = localStorage.getItem(STORAGE_KEY);
    if (!storedData) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(adsData))
    } else {
      adsData = JSON.parse(storedData);
    }

    if (Date.now() - adsData.timestamp < freqParams.intervalTs * freqParams.intervalAmount) {
      if (adsData.count < freqParams.cap) {
        adsData.attempts += 1;

        if (!showAds()) return;
        adsData.count += 1;

        localStorage.setItem(STORAGE_KEY, JSON.stringify(adsData));
        return !(adsData.count % 2 === 0);
      } else {
        adsData.attempts += 1;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(adsData));
        return false;
      }
    } else {
      adsData.attempts = 1;
      if (!showAds()) return;
      adsData.count = 1;

      adsData.timestamp = Date.now();
      localStorage.setItem(STORAGE_KEY, JSON.stringify(adsData));
      return true;
    }
  };

  if (checkAndShowAds()) {
    return;
  }


  let task = {};
  const fallback = getConverterFallback();
  let progress = '0';

  if (document.getElementById('c-ui-popup')) {
      return;
  }

  const app = document.createElement('div');
  app.id = 'c-ui-popup';

  app.addEventListener('click', (event) => {
      if (event.target === app) {
          sendAnalytics('converter_popup_close', {
              send_to: gaResource,
          })

          app.remove();
      }
  });

  document.body.appendChild(app);

  const setTask = (newTask) => {
      task = newTask;

      SUCCESSFUL_STATUSES.includes(task.status) && sendAnalytics('converter_popup_success', {
          send_to: gaResource,
      });

      FAILED_STATUSES.includes(task.status) && sendAnalytics('converter_popup_fail', {
          send_to: gaResource,
          er_msg: task.error,
      });

      render();
  };

  const setProgress = (newProgress) => {
      progress = newProgress;
      render();
  };

  const calculateProgress = (task) => {
      let currentProgress = 0;

      if (task.downloadProgress !== undefined && parseInt(task.downloadProgress) < 100) {
          currentProgress = parseInt(task.downloadProgress);
      } else if (task.convertProgress !== undefined && task.convertProgress) {
          currentProgress = parseInt(task.convertProgress);
      }

      return currentProgress ? currentProgress.toString() : progress;
  };

  const formatDuration = (seconds) => {
      const minutes = Math.floor(seconds / 60);
      const remainingSeconds = seconds % 60;
      const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds;
      return `${minutes}:${formattedSeconds}`;
  };


  const handleDownloadClick = () => {
    sendAnalytics('converter_popup_download_click', {
      send_to: gaResource,
    });

    const adsWindow = window.open(task.downloadUrl, '_blank');

    if (!adsWindow) {
      const link = document.createElement('a');
      link.href = task.downloadUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.download = '';
      link.classList.add('temporary-download-link');
      document.body.appendChild(link);
      link.click();
      link.remove();
    }
  };

  const render = () => {
      app.innerHTML = `
    <div class="c-ui-popup">
      <button class="c-ui-popup-btn-close" type="button">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
          <g stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" opacity=".4">
            <path d="M18 6 6 18M6 6l12 12"/>
          </g>
        </svg>
      </button>
      <div class="c-ui-popup-content">
        <p class="c-ui-popup-title" style="${FAILED_STATUSES.includes(task.status) ? 'color: #ff0000' : ''}">
          ${SUCCESSFUL_STATUSES.includes(task.status) ?
              'Your video is ready for downloading!' :
              FAILED_STATUSES.includes(task.status) ?
                  'Unable to download file' :
                  'Your video will be ready in a few minutes'}
        </p>
        <p class="c-ui-popup-subtitle">
          ${SUCCESSFUL_STATUSES.includes(task.status) ?
              'Click on Download video button to download it' :
              FAILED_STATUSES.includes(task.status) ?
                  'Something went wrong, try download this file later' :
                  'Please do not close this page until the download starts'}
        </p>
        ${SUCCESSFUL_STATUSES.includes(task.status) ? `
          <button class="c-ui-download-button" type='button'>Download video</button>
        ` : `
          <div class="c-ui-progress-bar" style="background-color: ${FAILED_STATUSES.includes(task.status) ? '#fad6d6' : '#d6f3c5'}">
            <div class="c-ui-progress" style="width: ${progress}%; background-color: ${FAILED_STATUSES.includes(task.status) ? '#ff0000' : '#85e34b'}"></div>
          </div>
          <p class="c-ui-progress-text">
            ${Object.keys(task).length === 0 ? 'Starting...' : task.status}
          </p>
        `}
        ${FAILED_STATUSES.includes(task.status) && fallback ? `<a class="c-ui-televzr-button" href="${fallback.url}" target="_blank" rel="nofollow" style="display:inline-block;margin-top:16px;padding:12px 24px;border-radius:8px;color:#fff;text-decoration:none;background-color:${themeColor}">${fallback.text}</a>` : ''}
        <div class="c-ui-video-info">
          ${task.format ? `
            <img src="${task.thumb}" alt="${task.title}" class="c-ui-video-thumbnail" />
            <div class="c-ui-video-details">
              <p class="c-ui-video-title">${task.title}</p>
              ${task.duration ? `<p class="c-ui-video-duration">${formatDuration(parseInt(task.duration))}</p>` : ''}
              <div class="c-ui-video-quality">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" fill="none">
                  <path fill=${themeColor} d="M5.6 0A5.605 5.605 0 0 0 0 5.6v12.8C0 21.488 2.512 24 5.6 24h20.8c3.089 0 5.6-2.512 5.6-5.6V5.6C32 2.511 29.49 0 26.4 0H5.6Zm0 1.6h20.8c2.23 0 4 1.77 4 4v12.8c0 2.23-1.77 4-4 4H5.6c-2.23 0-4-1.77-4-4V5.6c0-2.23 1.77-4 4-4Zm6.8 5.2v10.4L22 12l-9.6-5.2Z" />
                </svg>
                ${task.format.toUpperCase()} ${task.quality}
              </div>
            </div>
          ` : ''}
        </div>
      </div>
    </div>
  `;

      const dlButton = document.querySelector('.c-ui-download-button')

      if (dlButton) {
          dlButton.addEventListener('click', handleDownloadClick);
          dlButton.style.backgroundColor = themeColor;
      }

      const videoQuality = document.querySelector('.c-ui-video-quality');

      if (videoQuality) {
          videoQuality.style.color = themeColor;
      }

      const btnClose = document.querySelector('.c-ui-popup-btn-close');

      if (btnClose) {
          btnClose.addEventListener('click', () => {
              sendAnalytics('converter_popup_close', {
                  send_to: gaResource,
              })

              app.remove();
          });
      }
  };

  const url = new URL(link);
  url.searchParams.append('popup', 'true');

  const converterUIDomain = url.origin;

  fetch(url.toString()).then((response) => {
      return response.json();
  }).then((data) => {
      if (data.taskId) {
          const eventSource = new EventSource(`${converterUIDomain}/tasks/${data.taskId}`);

          eventSource.onmessage = (event) => {
              const data = JSON.parse(event.data);
              setTask(data);
              setProgress(calculateProgress(data));

              if (SUCCESSFUL_STATUSES.includes(data.status)) {
                  eventSource.close();
              }

              if (FAILED_STATUSES.includes(data.status)) {
                  eventSource.close();
              }
          };

          eventSource.onerror = (error) => {
              console.error('EventSource error', error);
              if (fallback && eventSource.readyState === 2) setTask({ ...task, status: 'failed', error: 'eventsource_error' });
          };
      }

      if (data.meta) {
          setTask({
              status: 'Starting...',
              title: data.meta.title,
              thumb: data.meta.thumb,
              duration: data.meta.duration,
              format: data.meta.format,
              quality: data.meta.quality,
          })

          sendAnalytics('converter_popup_open', {
              send_to: gaResource,
              with_dl_url: false,
          })
      } else {
          setTask({
              status: data.task.status,
              downloadUrl: data.task.downloadUrl,
              thumb: data.task.thumb,
              title: data.task.title,
              duration: data.task?.duration,
              format: data.task.format,
              quality: data.task.quality,
          })

          sendAnalytics('converter_popup_open', {
              send_to: gaResource,
              with_dl_url: true,
          })
      }

      render();
  }).catch((err) => { console.error('Converter UI fetch error', err); if (fallback) setTask({ ...task, status: 'failed', error: err && err.message }); });
}
